<div class="zoneiq-top-panel" style="justify-content: space-between;">
    <h3>Is Not Calibrated Reasons</h3>
    <div style="padding: 10px 0;"><button (click)="createReason()" class="button action" style="height: 45px;">Create Reason</button></div>
</div>
<div class="pt1 pb1 zoneiq-central-panel">
    <div class="pr1 pl1">
        <div class="general-items-table reasons-table">
            <div class="column-title flex between align-center">
                <span *ngFor="let field of tableFields">{{field}}</span>
            </div>
            <div class="table-body" cdkDropList cdkDropListLockAxis="y" (cdkDropListDropped)="dropReason($event)">
                <div *ngFor="let reason of reasons$ | async; let i = index" class="table-row reason-row flex between align-center"
                    cdkDrag cdkDragLockAxis="y" [cdkDragPreviewContainer]="'parent'"
                    [ngClass]="{'active': isSelectedRecord(reason)}">
                    <div class="row-sector drag-handle-cell flex align-center center" cdkDragHandle aria-label="Drag reason" title="Drag to reorder">
                        <span class="material-symbols-outlined drag-handle-icon" aria-hidden="true">drag_handle</span>
                    </div>
                    <div class="row-sector record-values-container" (dblclick)="setActiveRecord(i, reason)"
                        (focusout)="blurHandler($event.target)">
                        <div class="uses-input-container">
                            <input type="text" class="uses-input" [(ngModel)]="reason.Reason"
                                [readonly]="!isSelectedRecord(reason)">
                        </div>
                        <div class="record-errors-container">
                            <span *ngIf="!reason.importErrors?.length"></span>
                            <span *ngIf="reason.importErrors?.length" matTooltip="{{reason.importErrors}}"
                                [matTooltipClass]="'tooltip-header'" class="flex between align-center popup pr05">
                                <i class="material-icons error-icon">error</i>
                            </span>
                        </div>
                    </div>
                    <div class="row-sector record-values-container">
                        <span>{{ reason.IsDefault ? 'Yes' : 'No' }}</span>
                    </div>
                    <div class="flex actions-container">
                        <div class="action-buttons flex between align-center">
                            <div class="icon-button-container" (click)="editRecord(reason)"
                                *ngIf="!isSelectedRecord(reason)">
                                <i class="material-icons action-icon">edit</i>
                                <span class="flex between align-center popup">Edit</span>
                            </div>
                            <div class="icon-button-container" (click)="deleteRecord(reason.Id)"
                                *ngIf="!isSelectedRecord(reason)">
                                <i class="material-icons action-icon">close</i>
                                <span class="flex between align-center popup"> Delete</span>
                            </div>

                            <button mat-raised-button (click)="saveRecordModification()" [disabled]="!isValidRecord"
                                class="action action-button edit-mode-button" *ngIf="isSelectedRecord(reason)">Save
                            </button>
                            <button mat-raised-button (mousedown)="cancelRecordEdit()" *ngIf="isSelectedRecord(reason)"
                                class="action-button edit-mode-button">Cancel</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
